export default {
  base:{
    nextLanguage:'切换至中文'
  },
  myself:{
    ecard: 'E-Card',
    order: 'My Order',
    mydivecenter: 'My Dive Center',
    address: 'My Address',
    student: 'Students Info',
    jobs: 'SSI Jobs',
    helper: 'Help Center',
    about: 'About',
    loginout: 'Log out'
  },
  diveCenter: {
    sport: {
      sno: '浮潜',
      xr: '技术潜水',
      emergency: '技术潜水',
      ecology: '生态',
      scuba: '水肺潜水',
      freediving: '自由潜水',
      mermaid: '美人鱼',
      swim: '泳池',
      rebreather: '适应性潜水',
      instructor_training: '教练培训'
    }
  },
  diveType: {
    scubadiving: '水肺潜水',
    ecologyandreactright: '生态',
    freediving: '自由潜水',
    generalssi: '普通',
    snorkeling: '浮潜'
  }
}

